module.exports = __webpack_public_path__ + "img/hr-tileable-beam-START.ecae9160.png";